const AVAILABLE_CARD_TYPES = ['articleCard', 'videoCard', 'photoCard'];

export const prepareTimelineCards = (cards = []) => {
    const filteredCards = cards.filter(({ type }) =>
        AVAILABLE_CARD_TYPES.includes(type),
    );

    return filteredCards.slice(0, 4);
};
